<div class="content"> 
    <br>
 
<h4  style="display:inline-block;">Images</h4>
<button mat-raised-button class="primary" (click)="openImageUpload()" style="margin-left: 20px;"><mat-icon class="mr">add</mat-icon>Add</button>

<br> 
    </div>
    <!-- <div class="flex-container">
    <div class="flex-item" *ngFor="let i of project.projectImage">
        <img src={{i.imageContent}} width="300px"/> 
        <button mat-raised-button (click)="removeProjectImage(i)">X</button>
  
        </div>
        </div> -->

        <div ProjectImageDateDisplay *ngFor="let d of ProjectImageDateDisplay">
        <div class="flex-container"> 
                {{ d.uploadDate}}
                <br>
                <div class="flex-item" *ngFor="let i of d.projectImage">
                 
                    <div class="image-container" (click)="openProjectImageDisplay(i)">
                        <img src= {{i.imageContent}} alt="Click to expand" width="75px"/> 
                        <!-- <img [lazyLoad]="{{i.imageContent}}" [defaultImage]="defaultImage" alt="Click to expand" width="150px"/>   -->
                        <!-- <img data-src="i.imageContent" alt="Lazy Loaded Image" lazyLoad> -->
                        <!-- <ng-lazy-load-image [defaultImage]="'loading.gif'" src= {{i.imageContent}} ></ng-lazy-load-image>
                        [lazyLoad] -->
                      </div>

                    <button mat-raised-button (click)="removeProjectImage(i)">X</button>
              
                    </div>
                    </div>
            
            </div> 
         
        
 